import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorHandlerService } from '../error-handler.service';
import { AnimationsService } from '../animations.service';
import { environment } from '../../../environments/environment';
import { API } from '../api';
import { AuthService } from 'src/app/security/auth.service';

@Injectable({
  providedIn: 'root'
})
export class InconsistenciaDocumentoService {
  constructor(
    private http: HttpClient,
    private animationsService: AnimationsService,
    private errorHandlerService: ErrorHandlerService,
    private authService: AuthService,
  ) { }

  getAll(id): Observable<any> {
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.inconsistenciaDocumento.buscarTodos}?id=${id ? id : 0}`, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao obter os documentos', []))
      );
  }

  cadastrar(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.inconsistenciaDocumento.cadastrar}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
      );
  }

  buscarPorMatriculaId(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.inconsistenciaDocumento.buscarPorMatriculaId}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao excluir o documento', []))
      );
  }

  deletarPorId(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('inconsistenciaDocumentoId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.inconsistenciaDocumento.excluir}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao excluir o documento', []))
      );
  }
}
